import React from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/core';
import { Eye, Users, ExternalLink } from 'lucide-react';

export const EVENT_COLORS = {
  meeting: { bg: '#3B82F6', light: '#DBEAFE', text: '#1D4ED8', label: 'Réunion' },
  appointment: { bg: '#10B981', light: '#D1FAE5', text: '#047857', label: 'Rendez-vous' },
  inspection: { bg: '#F59E0B', light: '#FEF3C7', text: '#B45309', label: 'Visite/Inspection' },
  training: { bg: '#8B5CF6', light: '#EDE9FE', text: '#6D28D9', label: 'Formation' },
  deadline: { bg: '#EF4444', light: '#FEE2E2', text: '#B91C1C', label: 'Échéance' },
  reminder: { bg: '#6B7280', light: '#F3F4F6', text: '#374151', label: 'Rappel' },
  other: { bg: '#EC4899', light: '#FCE7F3', text: '#BE185D', label: 'Autre' }
};

export const EVENT_TYPES = Object.entries(EVENT_COLORS).map(([value, config]) => ({
  value, label: config.label, color: config.bg
}));

export const VISIBILITY_OPTIONS = [
  { value: 'private', label: 'Privé', icon: Eye },
  { value: 'team', label: 'Équipe', icon: Users },
  { value: 'public', label: 'Public', icon: ExternalLink }
];

export const REMINDER_OPTIONS = [
  { value: 0, label: 'Pas de rappel' },
  { value: 15, label: '15 minutes avant' },
  { value: 30, label: '30 minutes avant' },
  { value: 60, label: '1 heure avant' },
  { value: 1440, label: '1 jour avant' }
];

export const WEEKDAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export const formatTime = (datetime) =>
  new Date(datetime).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

export const formatDate = (datetime) =>
  new Date(datetime).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });

export function DraggableEvent({ event, children }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: event.id, data: { event }
  });
  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    opacity: isDragging ? 0.5 : 1, cursor: 'grab', touchAction: 'none'
  };
  return <div ref={setNodeRef} style={style} {...listeners} {...attributes}>{children}</div>;
}

export function DroppableDay({ date, children }) {
  const dateStr = date.toISOString().split('T')[0];
  const { setNodeRef, isOver } = useDroppable({ id: `day-${dateStr}`, data: { date } });
  return (
    <div ref={setNodeRef} className={`transition-colors ${isOver ? 'ring-2 ring-blue-500 bg-blue-50' : ''}`}>
      {children}
    </div>
  );
}
